import ViewManager from '../../../managers/view';

export default class StickyBanner {

  constructor(element){
    this.element = element;

    this.offsetHeight = null;
    this.offsetTop = null;
    this.liveChatIsLoaded = false;

    this.init();
  }


  init() {
    this.onViewUpdate = ::this.onViewUpdate;
    this.onViewWillUpdate = ::this.onViewWillUpdate;

    ViewManager.on(ViewManager.EVENT_WILL_UPDATE, this.onViewWillUpdate);
    ViewManager.on(ViewManager.EVENT_UPDATE, this.onViewUpdate);

    this.offsetTop = this.element.offsetTop;
    this.offsetHeight = this.element.offsetHeight;

    this.pollLiveChat();
  }


  onViewWillUpdate(data) {
    if (data.resizeUpdate) {
      this.offsetTop = this.element.offsetTop;
      this.offsetHeight = this.element.offsetHeight;
    }
  }


  pollLiveChat() {
    const node = this.element.querySelector('#lpButtonDiv');

    const timeouts = [100, 500, 1000, 5000, 20000];

    if (node) {
      this.checkLiveChatLoad(node, timeouts);
    }
  }


  checkLiveChatLoad(node, timeouts) {
    if (node.children.length > 1) {
      this.offsetHeight = this.element.offsetHeight;

    } else {
      if (timeouts.length > 0) {
        const time = timeouts.shift();

        setTimeout(() => {
          this.checkLiveChatLoad(node, timeouts);
        }, time);
      }
    }
  }


  onViewUpdate(data) {
    const {viewHeight, scrollTop} = data;

    const top = (viewHeight - this.offsetHeight) / 2;

    if (scrollTop + top > this.offsetTop && this.offsetHeight < window.innerHeight) {

      this.element.classList.add('sticky-banner--fixed');
    } else {
      this.element.classList.remove('sticky-banner--fixed');
    }
  }
}
